import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";

export default function PromoBannerSimple({
  title,
  description,
  className,
}: BasePromoBannerProps) {
  return (
    <div
      className={`bg-secondary-500 text-primary-foreground rounded-xl pt-8 pb-8 pl-10 pr-10 ${className || ""}`}
    >
      <div className="items-center gap-2.5">
        <span className="font-black italic text-[30px]">{title}</span>
        {description && (
          <>
            <span> </span>
            <PromoBannerTooltip
              htmlContent={
                typeof description === "string" ? description : undefined
              }
            />
          </>
        )}
      </div>
    </div>
  );
}
